<template>
	<div class="list-container column">
		<div class="title">{{ $t('roundplanninglist.title') }}</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('roundplanninglist.name') }}</div>
			<div class="panel-header-item">{{ $t('roundplanninglist.customer') }}</div>
			<div class="panel-header-item" v-if="!isMobile">{{ $t('roundplanninglist.description') }}</div>
			<div class="panel-filler" />
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="roundPlanning in roundPlannings"
			:key="roundPlanning.id"
			@click.stop="onEdit(roundPlanning)"
		>
			<p class="panel-list-item">{{ roundPlanning.name }}</p>
			<p class="panel-list-item">
				{{ roundPlanning.customerName || "-" }}
			</p>
			<p class="panel-list-item" v-if="!isMobile">
				{{ roundPlanning.description }}
			</p>
			<div v-if="$isAllowedTo('roundplannings_edit')" class="list-button" @click.stop="onEdit(roundPlanning)">
				<i class="fas fa-edit"></i>
			</div>
			<div v-if="$isAllowedTo('roundplannings_delete')" class="list-button" @click.stop="onDelete(roundPlanning)">
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="roundPlannings.length == 0">
			<p class="header-item">{{ $t('roundplanninglist.no_results') }}</p>
		</div>
		<Pagination
			v-if="roundPlannings.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>


<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},

	props: {
		roundPlannings: Array
	},

	computed: {
		...mapGetters('roundPlanningStore', ['pagination']),
		...mapGetters('appStore', ['isMobile'])
	},

	methods: {
		...mapActions('roundPlanningStore', ['setCurrentPage', 'setPageSize']),
		onDelete(roundPlanning) {
			if (!this.$isAllowedTo('roundplannings_delete')) return;
			this.$emit('delete', roundPlanning);
		},
		onEdit(roundPlanning) {
			if (!this.$isAllowedTo('roundplannings_edit')) return;
			this.$emit('edit', roundPlanning);
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	}
};
</script>
